var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0006 1.49902V4.49963H8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74475 7.00024C9.41967 7.92038 8.80433 8.70994 7.99147 9.24994C7.17861 9.78994 6.21226 10.0511 5.23805 9.99413C4.26383 9.93714 3.33453 9.56506 2.59018 8.93396C1.84583 8.30286 1.32676 7.44694 1.11119 6.49516C0.895619 5.54339 0.995224 4.54734 1.395 3.6571C1.79477 2.76686 2.47305 2.03067 3.32763 1.55946C4.18221 1.08826 5.16679 0.907562 6.133 1.04461C7.09921 1.18166 7.9947 1.62903 8.68454 2.3193L11 4.49973",
    stroke: "#122D52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.d244b19305c5b1da8902a8256a2e46ec.svg";
export { ForwardRef as ReactComponent };